<template>
    <div>
        <buttonlist @help="help" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <el-table
                        id="xpane-0"
                        :data="dataSet"
                        ref="singleTable"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        size="mini"
                        :height="tableHeight"
                        @row-click="editInfo"
                        @row-dblclick="openEdit"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection" v-if="false"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="item_no" :label="$t('getapi[2095]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[137]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="item_name" :label="$t('getapi[546]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="client_code" :label="$t('getapi[2610]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="item_duty_person" :label="$t('getapi[6403]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="item_status_name" :label="$t('getapi[7943]')"></el-table-column>
                </el-table>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div style="width:930px">
                    <el-button type="primary" size="mini" @click="itemConfirm" :disabled="user != dataDetail.Head.create_person || dataDetail.Head.status != 0 || dataDetail.Head.item_no == ''">{{$t('getapi[2051]')}}</el-button>
                    <table>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[2095]') }}</td>
                            <td style="width:150px;">
                                <el-input v-model="dataDetail.Head.item_no" type="text"  style="width: 150px"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            
                            <td style="width:60px">{{ $t('getapi[1861]') }}</td>
                             <td style="width:150px;">
                                <el-input :value="dataDetail.Head.status_name" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            
                            
                            <td style="width:80px">{{$t('getapi[8000]')}}</td>
                            <td style="width:150px">
                                <routejump :urlNo="16">
                                <el-select filterable v-model="templateid" @change="selectChanged" :disabled="dataDetail.Head.exclusively_id>0" size="mini"> 
                                    <el-option v-for="item in downdatajson" :key="item.id"
                                            :label="item.name" :value="item.id"></el-option>
                                </el-select>
                                </routejump>
                            </td>
                            <td style="width:60px">{{ $t('getapi[6403]') }}</td>
                            <td style="width:100px;">
                                <el-input :value="dataDetail.Head.item_duty_person" type="text" size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[3437]') }}</td>
                            <td style="width:150px;">
                                <routejump :urlNo="5" v-show="addoredit == 1">
                                <el-input
                                        v-model="dataDetail.Head.item_code"
                                        type="text"
                                        readonly

                                        size="mini"
                                        class="mcolor"
                                        style="width: 150px"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectItem()"></i>
                                </el-input>
                                </routejump>
                                <el-input v-model="dataDetail.Head.item_code" v-show="addoredit != 1" :readonly="true" class="readO"
                                          size="mini"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[546]') }}</td>
                            <td style="width:150px;">
                                <el-input v-model="dataDetail.Head.item_name" type="text" size="mini" style="width: 150px" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[2610]') }}</td>
                            <td style="width:100px;">
                                <el-input v-model="dataDetail.Head.client_code" type="text" size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[7943]') }}</td>
                            <td style="width:100px;">
                                <el-input :value="dataDetail.Head.item_status_name" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
                <el-tabs :tab-position="'top'" type="" style="margin-top: 5px">
                    <el-tab-pane :label="$t('getapi[3360]')" name="0">
                        <quill-editor
                                ref="text"
                                v-model="dataDetail.Head.description"
                                :height="tableHeight - 100"
                                class="myQuillEditor"
                                :options="quillOption"/>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[7959]')" name="1">
                        <vxe-table
                                :data="dataDetail.DatailList"
                                :highlight-current-row="true"
                                style="width: 100%; margin-top:3px"
                                resizable
                                show-overflow="tooltip"
                                :height="tableHeight - 150"
                                header-row-class-name="headerclass"
                                :row-class-name="tableRowClassName1"
                                size="mini"
                                border
                                ref="singleTable1"
                        >
                            <vxe-table-column type="checkbox" align="center" field="isenable"  width="40" v-if="false"></vxe-table-column>
                            <!-- <vxe-table-column show-footer-overflow field="isenable"  :title="$t('getapi[6158]')" width="80"></vxe-table-column> -->
                            <!-- <vxe-table-column show-footer-overflow field="relation_itemno" :title="$t('getapi[463]')"  width="100"></vxe-table-column> -->
                            <vxe-table-column align="center" field="isenable" :title="$t('getapi[6158]')"  width="80">
                                <template slot-scope="scope">
                                    <el-checkbox v-model="scope.row.isenable" :true-label=1 :false-label=0>
                                    </el-checkbox>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="itemstage" :title="$t('getapi[7944]')"  width="120"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="item_strategyno" :title="$t('getapi[1297]')"  width="100"></vxe-table-column>
                            <!-- <vxe-table-column show-footer-overflow field="department_no" :title="$t('getapi[7945]')"  width="100"></vxe-table-column> -->
                            <vxe-table-column show-footer-overflow field="content" :title="$t('getapi[6160]')"  width="150"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="blamedept" :title="$t('getapi[8001]')"  width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="blamepeople" :title="$t('getapi[7946]')"  width="100"></vxe-table-column>
                            <vxe-table-column field="plan_person" :title="$t('getapi[6161]')"  width="150">
                                <template slot-scope="scope">
                                    <el-input
                                            v-model="scope.row.plan_person"
                                            type="text"
                                            readonly
                                            size="mini"
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectPlanPerson(scope)"></i>
                                    </el-input>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column field="plan_time" :title="$t('getapi[6162]')"  width="150">
                                <template slot-scope="scope">
                                    <el-date-picker
                                            v-model="scope.row.plan_time"
                                            type="date"
                                            value-format="yyyy/MM/dd"
                                            @blur="checkfclick(scope)"
                                            size="mini"
                                            style="width:100%"
                                    ></el-date-picker>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column field="complete_time" :title="$t('getapi[6163]')"  width="150"></vxe-table-column>
                            <!-- <vxe-table-column show-footer-overflow field="complete_time" :title="$t('getapi[6163]')"  width="150">
                                <template slot-scope="scope">
                                    <el-date-picker
                                            v-model="scope.row.complete_time"
                                            type="date"
                                            value-format="yyyy/MM/dd"
                                            size="mini"
                                            style="width:100%"
                                    ></el-date-picker>
                                </template>
                            </vxe-table-column> -->
                            <vxe-table-column align="center" :title="$t('getapi[6048]')" width="70">
                                <template slot-scope="scope" v-if="scope.row.exclusively_id != 0">
                                    <el-button slot="reference" type="text" size="mini" @click.native.prevent="files(scope)" >
                                        {{$t('getapi[6225]')}}
                                    </el-button>
                                </template>
                            </vxe-table-column>
                        </vxe-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[7960]')" name="2">
                        <vxe-table
                                :data="dataDetail.SignList"
                                :highlight-current-row="true"
                                style="width: 100%; margin-top:3px"
                                resizable
                                show-overflow="tooltip"
                                :height="tableHeight - 150"
                                header-row-class-name="headerclass"
                                size="mini"
                                border
                        >
                            <vxe-table-column type="checkbox" align="center" width="40"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="signature_strategyno" :title="$t('getapi[871]')"  width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="role_name" :title="$t('getapi[7949]')"  width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="user_name" :title="$t('getapi[7950]')"  width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="opinion" :title="$t('getapi[6180]')" width="150"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="opinion_time" :title="$t('getapi[6181]')" width="100"></vxe-table-column>
                            <vxe-table-column field="opinion_status" :title="$t('getapi[552]')" width="100">
                                <template slot-scope="scope">
                                    <el-input v-show="scope.row.opinion_status == -1" :value="$t('getapi[8724]')" disabled></el-input>
                                    <el-input v-show="scope.row.opinion_status == 0" :value="$t('getapi[6188]')" disabled></el-input>
                                    <el-input v-show="scope.row.opinion_status == 1" :value="$t('getapi[6187]')" disabled></el-input>
                                </template>
                            </vxe-table-column>
                            <!-- <vxe-table-column show-footer-overflow field="user_name_backup" :title="$t('getapi[7951]')"  width="100"></vxe-table-column> -->
                            <vxe-table-column :title="$t('getapi[6048]')" width="70" align="center">
                                <template slot-scope="scope">
                                    <el-button  @click.native.prevent="signClick(scope)" type="text" size="small">
                                        {{$t('getapi[6048]')}}
                                    </el-button>
                                </template>
                            </vxe-table-column>
                        </vxe-table>
                    </el-tab-pane>
                </el-tabs>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="ItemManagerInfo" ref="ser" @getser="serclick"></serce>

        <selector :isVisible="false" :isBatch=false :isSplitPage=true
                  :postUrl="'/Eng/ItemManage/GetEngItemPopupView'" @callback="getItem" ref="item"></selector>
        <!--实施计划负责人 -->
        <selector :isVisible="false" :selectType="8" :isSplitPage="true" :postUrl="'Basic/Popup/GetEmployeeDataList'"
                  @callback="getPlanPerson" ref="planperson"></selector>

        <el-dialog v-dialogDrag :visible.sync="isVisiblefile" :title="$t('getapi[6225]')" width="65%">
            <div style="display: flex">
                <el-upload :show-file-list="false" class="upload-demo"
                           :data="fileparm"
                           :action="fileurl"
                           :on-change="handleChange"
                           :on-success="handleSuccess">
                    <el-button size="mini" type="primary">{{$t('getapi[3591]')}}</el-button>
                </el-upload>
                <el-button size="mini" type="primary" @click="addline" style="margin-left: 8px">{{$t('getapi[878]')}}</el-button>
                <el-button size="mini" type="primary" @click="batchdel" :disabled="selectData.length < 1">{{$t('getapi[40]')}}</el-button>
            </div>
            <el-table :data="FileLists" border height="400" size="mini" style="width: 100%;"
                      header-row-class-name="headerclass"
                      @selection-change="handleSelectionChange"
                      :row-class-name="tableRowClassName">
                <el-table-column type="selection"></el-table-column>
                <el-table-column prop="filename" :label="$t('getapi[3590]')" width="150">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.filename"  size="mini" v-if="scope.row.data_type == 2"></el-input>
                        <el-input v-model="scope.row.filename"  size="mini" readonly="true" v-if="scope.row.data_type == 1"></el-input>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="doc_type" :label="$t('getapi[3605]')" width="100">
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="doc_size" :label="$t('getapi[7875]')" width="100">
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="upload_person" :label="$t('getapi[6425]')" width="100">
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="upload_time" :label="$t('getapi[6426]')" width="130">
                </el-table-column>
                <el-table-column prop="path" :label="$t('getapi[7952]')" width="300">
                    <template slot-scope="scope">                        
                        <template v-if="scope.row.upload_person==user || user==dataDetail.Head.item_duty_person || issecrecy == 0 || (btn.canupload && issecrecy==1)">
                            <el-input v-model="scope.row.path"  size="mini"  v-if="scope.row.data_type == 2"></el-input>
                            <el-input v-model="scope.row.path"  size="mini" readonly="true"  v-if="scope.row.data_type == 1"></el-input>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('getapi[6048]')">
                    <template slot-scope="scope">
                        <el-button slot="reference" type="text" size="small" v-if="scope.row.upload_person==user"  @click.native.prevent="filedel(scope)">{{$t('getapi[40]')}}
                        </el-button>
                        <!-- 上传人、项目负责人、不保密、已授权 可以查看附件 -->
                        <el-button slot="reference" type="text" size="small" v-if="scope.row.upload_person==user || user==dataDetail.Head.item_duty_person || issecrecy == 0 || (btn.canupload && issecrecy==1)"  @click.native.prevent="open(scope)">{{$t('getapi[3558]')}}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isVisiblefile = false">{{$t('getapi[2054]')}}</el-button>
				<el-button type="primary" @click="saveFile">{{$t('getapi[937]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag center :title="$t('getapi[6186]')" :visible.sync="dialogVisible" width="30%">
            <el-input v-model="sign.opinion" type="textarea" :rows="5" show-word-limit></el-input>
            <span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">{{$t('getapi[6]')}}</el-button>
				<el-button type="primary" @click="confirmSign(0)">{{$t('getapi[6187]')}}</el-button>
				<el-button type="warning" @click="confirmSign(1)">{{$t('getapi[6188]')}}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import Quill from 'quill';
    import {quillEditor} from 'vue-quill-editor';
    import 'quill/dist/quill.core.css';
    import 'quill/dist/quill.snow.css';
    import 'quill/dist/quill.bubble.css';
    import {container, ImageExtend} from 'quill-image-extend-module';
    import {Loading} from 'element-ui';
    Quill.register('modules/ImageExtend', ImageExtend);
    import quillConfig from '@/utils/config.js';
    import { encryptDes, decryptDes,generatekey } from '@/utils/des.js'
    export default {
        components: {
            quillEditor
        },
        name: 'itemmanage',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                quillOption: quillConfig,
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                user: '',
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('itemmanage'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                dataDetail: {
                    Head: {},
                    DatailList: [],
                    FileList: [],
                    SignList:[],
                }, // 编辑页面数据详情
                oldDataDetail: '',
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                addoredit: 1,
                code: '', // 单据唯一号
                rowindex: '',
                fileurl: '',
                fileparm: {
                    Code: '',
                    Data_Type: 10,
                    Login_Group:'',
                    Login_DB:'',
                    itemdetailid: '',
                },
                FileLists: [],
                FileList: [],
                downdatajson:[],
                templateid:0,
                isVisiblefile: false,
                issecrecy:0,
                filecode: '', // 项目清单code
                selectData:[],
                dialogVisible: false,
                sign: {
                    exclusively_id: 0,
                    relation_itemno: '',
                    signature_strategyno: '',
                    opinion_person: '',
                    opinion: '',
                    opinion_time: '',
                    role_name: '',
                    user_name: '',
                    opinion_status: 0
                },
                btn: {
                    canupload: false
                },
                scrollTop:0,
                scrollTop1:0,
            };
        },
        mounted: function () {
            let that = this;
            that.$processdata.pushModelCache('itemmanage', that)
            that.userData = sessionStorage.getItem('userData');
            that.user = JSON.parse(that.userData).username;
            let token = JSON.parse(that.userData).token;
            that.fileurl = Common.FileUrl+ '/Files/UpFileByDocManage?token=' + token;
            that.$limits.dragControllerDiv();
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.downdata();
            that.authority()
            that.$nextTick(function () {
                that.$processdata.initForm()
            })
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                }, 13)
            })

        },
        methods: {
            // 获取数据
            downdata() {
                let that = this;
                that.loading = true;
                this.isVisible = false;
                that.$http.urlpost('/Eng/ItemImple/GetItemSTemplateDownList', {}, function(res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.downdatajson = res.DataContent;
                        that.templateid=that.downdatajson[0].id;
                    }
                    that.loading = false;
                    that.authority();
                });
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[7934]"),this.$t("getapi[18]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                if (that.$limits.authority('plv2', 527, 1) == 1) {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                }
                else if (that.$limits.authority('plv2', 527, 1) == 2) {
                    if (that.$limits.authority('plv3', 527,1) == 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 527, 1) == 1) {
                        //编辑级
                        that.$refs.SetBtn.SetButtonEnable('search,create,save,refresh,export');
                    }
                    if (that.$limits.authority('plv3', 527, 1) == 2) {
                        //删除级
                        if (!that.$limits.fnIsEmpty(that.dataDetail.Head.item_no)){
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,del');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('search,create,save,refresh,export');
                        }
                    }
                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this
                that.btn.canupload = false
                if(that.$limits.authority('plv4', 527, 1) >0){
                    that.btn.canupload = true
                }
            },
             tableRowClassName1({row, rowIndex}) {
                row.index = rowIndex;
                if (row.ismust == 1 && row.exclusively_id<=0) {
                    return 'yellow';
                }
            },
            tableRowClassName({row, rowIndex}) {
                row.index = rowIndex;
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if (!that.iscontinuedblclick) {
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit() {
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('itemmanage',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'ItemManagerInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Eng/ItemManage/ItemManageView', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.$nextTick(function(){
                        that.$processdata.initForm(that.SelectIndexs)
                    });
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this;
                if (that.code == row.item_no) {
                    return
                }
                that.timeId = setTimeout(() => {
                    let datacopy = that.dataDetail
                    for(let i = 0;i<datacopy.DatailList.length;i++){
                        delete datacopy.DatailList[i]['index'];
                        delete datacopy.DatailList[i]['_XID'];
                    }
                    for(let i = 0;i<datacopy.SignList.length;i++){
                        delete datacopy.SignList[i]['index'];
                        delete datacopy.SignList[i]['_XID'];
                    }
                    if (that.oldDataDetail != JSON.stringify(datacopy)) {
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.code = row.item_no;
                                that.getDetail(that.code);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.code = row.item_no;
                        that.getDetail(that.code);
                    }
                }, 100);
            },
            // 获取详情数据
            getDetail(code) {
                let that = this;
                that.dloading = true;
                that.addoredit = 2;
                that.selectData = [];
                that.dataChecked = [];
                let parm = {
                    Code: code
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Eng/ItemManage/GetItemManagerInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        // console.log("测试数据:"+JSON.stringify(that.dataDetail))
                        that.templateid=that.dataDetail.DatailList[0].itemstemid;
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                        that.btnauthority();
                    }
                    that.dloading = false;
                    loadingInstance.close()
                });
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.DatailList.length;i++){
                    delete datacopy.DatailList[i]['index'];
                    delete datacopy.DatailList[i]['_XID'];
                }
                for(let i = 0;i<datacopy.SignList.length;i++){
                    delete datacopy.SignList[i]['index'];
                    delete datacopy.SignList[i]['_XID'];
                }
                if (that.oldDataDetail != JSON.stringify(datacopy)) {
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd() {
                let that = this;
                let datetime = Common.methods.getDatetime();
                that.addoredit = 1;
                that.code = ''
                that.dataDetail = {
                    Head: {
                        exclusively_id: 0,
                        item_no: '',
                        itemid: '',
                        item_code: '',
                        item_name: '',
                        client_code: '',
                        item_duty_person: '',
                        item_status: '',
                        item_status_name: '',
                        status: 0,
                        status_name: '',
                        description: '',
                        create_person: that.user,
                        create_time: datetime,
                        modify_person: '',
                        modify_time: ''
                    },
                    DatailList: [],
                    FileList: [],
                    SignList: [],
                };
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.getItemInfo()
                that.authority();
            },
            selectChanged(){
                this.getItemInfo();
            },
            getItemInfo(){
                let that = this
                let parm = {
                    Id:that.templateid
                };
                that.$http.urlpost('/Eng/ItemManage/GetAddItemInfo', parm, function (res) {
                    if (res.Success == 1) {
                        if(res.DataContent){
                            that.dataDetail.DatailList = res.DataContent.StrategyList
                            that.dataDetail.SignList = res.DataContent.SignList
                            that.oldDataDetail = JSON.stringify(that.dataDetail)
                        }
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.DatailList.length;i++){
                    delete datacopy.DatailList[i]['index'];
                    delete datacopy.DatailList[i]['_XID'];
                }
                for(let i = 0;i<datacopy.SignList.length;i++){
                    delete datacopy.SignList[i]['index'];
                    delete datacopy.SignList[i]['_XID'];
                }
                console.log(that.oldDataDetail)
                console.log(JSON.stringify(datacopy))
                if (that.oldDataDetail != JSON.stringify(datacopy)) {
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            if (that.addoredit != 1) {
                                that.getView();
                                that.getDetail(that.code)
                            } else {
                                that.getView();
                                that.confirmAdd()
                            }
                        });
                } else {
                    if (that.addoredit != 1) {
                        that.getView();
                        that.getDetail(that.code)
                    } else {
                        that.getView();
                        that.confirmAdd()
                    }
                }
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndexs,
                    Ids: '',
                    Param: datac,
                    LangType: that.$processdata.getLang(),
                    fromname: that.$t('getapi[7934]')
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps', false);
                that.$http.urlpost('/Eng/ItemManage/ItemManageViewToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps', true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            // 保存
            save() {
                let that = this;
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                let parm = that.dataDetail;
                that.$http.urlpost('/Eng/ItemManage/SaveItemManager', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        let parm = res.UniqueNum;
                        that.code = parm;
                        that.getDetail(parm);
                    }
                });
            },
            // 删除
            del(){
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            Code: that.code
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del',false);
                        that.$http.urlpost('/Eng/ItemManage/DeleteItemManager', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del',true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 选择项目信息
            selectItem(){
                let that = this
                that.$refs.item.clearInput(true);
            },
            getItem(val){
                let that = this
                console.log(val)
                that.dataDetail.Head.item_code = val.item_code
                that.dataDetail.Head.item_name = val.item_name
                that.dataDetail.Head.client_code = val.client_code                
                that.dataDetail.Head.itemid = val.exclusively_id
            },
            // 上传
            files(val) {
                let that = this;
                this.FileLists = [];
                this.issecrecy=val.row.issecrecy;
                this.fileparm.Code = val.row.relation_itemno;
                this.FileList.forEach(item => {
                    if (item.Code == val.row.relation_itemno) {
                        this.FileLists.push(item);
                    }
                })
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.fileparm.Login_Group=encryptDes(JSON.parse(that.userData).Login_Group,key);
                that.fileparm.Login_DB=encryptDes(JSON.parse(that.userData).Login_DB,key);
                that.fileparm.itemdetailid=val.row.exclusively_id
                that.filecode = val.row.exclusively_id
                let parm = {
                    Id: val.row.exclusively_id,
                    LangType:  that.$processdata.getLang(),
                }
                that.$http.urlpost('/Eng/ItemManage/GetItemFilesLists', parm, function (res) {
                    if (res.Success == 1) {
                        that.FileLists=res.DataContent.FileList;
                    }
                });
                this.isVisiblefile = true;
            },
            handleChange(file, fileList) {
                this.FileList = fileList.slice(-3);
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log('------handleSuccess---', res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(res.Msg);
                } else {
                    that.$message.success(res.Msg);
                    that.getfiles()
                }
            },
            addline(){
                let that = this
                let datetime = Common.methods.getDatetime()
                that.FileLists = [...that.FileLists,{
                    exclusively_id:0,
                    itemdetailid:that.filecode,
                    relation_itemno:that.dataDetail.Head.item_no,
                    filename:'',
                    upload_time:datetime,
                    upload_person:that.user,
                    doc_type:'',
                    doc_size:'',
                    data_type:2,
                    path:''
                }]
            },
            handleSelectionChange(val){
                let that = this;
                that.selectData = val;
            },
            batchdel(){
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            ids: '',
                            FilesSrc: ''
                        };
                        for (let i = that.selectData.length - 1; i >= 0; i--) {
                            that.FileLists.splice(that.selectData[i].index, 1);
                            if(that.selectData[i].exclusively_id!=0){
                                parm.ids = parm.ids + that.selectData[i].exclusively_id + ','
                                parm.FilesSrc = parm.FilesSrc + that.selectData[i].path + ','
                            }
                        }
                        if(parm.ids.length>0){
                            that.$http.urlpost('/Eng/ItemManage/DelItemFileByID', parm, function (res) {
                                if (res.Success == 1) {
                                    console.log("测试"+JSON.stringify(res))
                                    that.getfiles();
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            filedel(val){
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        if(val.row.exclusively_id == 0){
                            that.FileLists.splice(val.$index, 1)
                        } else {
                            let parm = {
                                ids: val.row.exclusively_id,
                                FilesSrc: val.row.FilesSrc
                            }
                            that.$http.urlpost('/Eng/ItemManage/DelItemFileByID', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    that.getfiles();
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            open(val){
                let that = this
                if(val.row.data_type==1){
                    window.open(val.row.path);
                }
                if(val.row.data_type==2){
                    window.open(val.row.path,"_blank");
                }
            },
            saveFile(){
                let that = this
                let parm = that.FileLists
                that.$http.urlpost('/Eng/ItemManage/SaveItemFiles', parm, function (res) {
                    if (res.Success == 1) {
                        that.getfiles();
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                          
                    }
                });
            },
            getfiles(){
                let that=this;
                let parm = {
                    Id: that.filecode,
                    LangType:  that.$processdata.getLang(),
                }
                that.$http.urlpost('/Eng/ItemManage/GetItemFilesLists', parm, function (res) {
                    if (res.Success == 1) {
                        that.FileLists=res.DataContent.FileList;
                    }
                });
            },
            // 会签
            signClick(val){
                let that = this
                let datetime = Common.methods.getDatetime()
                that.sign = {
                    exclusively_id: val.row.exclusively_id,
                    relation_itemno: that.dataDetail.Head.item_no,
                    signature_strategyno: val.row.signature_no,
                    opinion_person: that.user,
                    opinion: '',
                    opinion_time: datetime,
                    role_name: val.row.role_name,
                    user_name: val.row.user_name,
                    opinion_status: 0
                };
                that.dialogVisible = true;
            },
            confirmSign(type){
                let that = this
                that.sign.opinion_status = type
                let parm = that.sign
                parm.LangType = that.$processdata.getLang()
                if(type == 0){
                    that.$http.urlpost('/Eng/ItemManage/SignOK_Click', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.dialogVisible = false
                            that.getDetail(that.code)
                        }
                    });
                } else {
                    that.$http.urlpost('/Eng/ItemManage/SignNoClick', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.dialogVisible = false
                            that.getDetail(that.code)
                        }
                    });
                }
            },
            // 确认
            itemConfirm(){
                let that = this
                let parm = {
                    exclusively_id: that.dataDetail.Head.exclusively_id,
                    item_no: that.dataDetail.Head.item_no,
                    modify_time: that.dataDetail.Head.modify_time,
                    status: that.dataDetail.Head.status,
                    LangType: that.$processdata.getLang(),
                }
                that.$http.urlpost('/Eng/ItemManage/ItemConfirm', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code)
                    }
                });
            },
            //
            selectPlanPerson(row){
                let that = this
                that.rowindex = row.$rowIndex;
                that.$refs.planperson.clearInput(true);
            },
            getPlanPerson(val){
                let that = this
                that.dataDetail.DatailList[that.rowindex].plan_person = val.name + '(' + val.code + ')'
            },
            checkfclick(val) {
                let that = this
                that.rowindex = val.$rowIndex;
                that.dataDetail.DatailList[that.rowindex].isenable = 1;
            },
            checkDataChange() {
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 527,1) < 1){
                    return false
                }
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.DatailList.length;i++){
                    delete datacopy.DatailList[i]['index'];
                    delete datacopy.DatailList[i]['_XID'];
                }
                for(let i = 0;i<datacopy.SignList.length;i++){
                    delete datacopy.SignList[i]['index'];
                    delete datacopy.SignList[i]['_XID'];
                }
                let flag = that.oldDataDetail != JSON.stringify(datacopy)
                return flag
            },

        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .red {
        background: #ff7879;
    }

    .quill-editor.myQuillEditor {
        height: 600px;
        overflow-y: auto;
    }
    /deep/.yellow{
        background: #EE7700;
    }
</style>
